"use client";

import { Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import SignupPage from "./SignupPage";
import { getSafeRedirectPath } from "@/lib/auth/redirect";

function SignupContent() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirectTo = getSafeRedirectPath(
    searchParams.get("redirectTo"),
    "/onboarding/user-identification",
  );

  const handleBackClick = () => {
    router.push("/");
  };

  const handleLoginClick = () => {
    router.push(`/auth/login?redirectTo=${encodeURIComponent(redirectTo)}`);
  };

  return (
    <SignupPage
      onBackClick={handleBackClick}
      onLoginClick={handleLoginClick}
      redirectTo={redirectTo}
    />
  );
}

export default function Signup() {
  return (
    <Suspense fallback={null}>
      <SignupContent />
    </Suspense>
  );
}
